import { Form, Switch } from "antd";
import React from "react";

const Hypertensive: React.FC = () => {
  return (
    <Form.Item
      name={["subjectMetric", "isHypertensive"]}
      label="Hypertensive"
      valuePropName="checked"
    >
      <Switch  defaultValue={false} />
    </Form.Item>
  );
};

export default Hypertensive;
